import { uiToast } from '../ui/component/toast';
import { $api } from '../y/api';
import { YLanguage } from '../y/i18n';

interface UTranslateResponse {
    text: string;
}

export function uTranslateText(text: string, src: YLanguage, dst: YLanguage, html?: boolean) {
    return $api.POST<UTranslateResponse>('u/translate', { text, src, dst, html });
}

export function uInputTranslator(text: string, src: YLanguage, dst: YLanguage) {
    return uTranslateText(text, src, dst).then(r => {
        return r.text;
    }, message => {
        uiToast(message);
        throw message;
    });
}
